import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import DiceNeutral from "@/shared/ui/Icon/svg/DiceNeutral.vue";
import DiceNegative from "@/shared/ui/Icon/svg/DiceNegative.vue";
import DicePositive from "@/shared/ui/Icon/svg/DicePositive.vue";
import LuckyDicePositive from "@/shared/ui/Icon/svg/LuckyDicePositive.vue";
import LuckyDiceNeutral from "@/shared/ui/Icon/svg/LuckyDiceNeutral.vue";
import { DiceResult } from "@/shared/helpers/roll";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RollResult',
  props: {
	result: {
		type: Array as PropType<DiceResult[]>,
		default: () => [],
	},
	column: {
		type: Boolean,
		default: false,
	},
	size: {
		type: Number,
		default: 60,
	},
},
  setup(__props) {

_useCssVars(_ctx => ({
  "2554c651": (__props.size)
}))



const getDiceComponent = (result: DiceResult) => {
	const dices = {
		DiceNeutral,
		DiceNegative,
		DicePositive,
		LuckyDicePositive,
		LuckyDiceNeutral,
	};
	if (result.dice === "lucky") {
		if (result.result) {
			return dices["LuckyDicePositive"];
		}
		return dices["LuckyDiceNeutral"];
	}
	if (result.result === -1) {
		return dices["DiceNegative"];
	}
	if (result.result) {
		return dices["DicePositive"];
	}
	return dices["DiceNeutral"];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass({ column: __props.column })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.result, (die, index) => {
      return (_openBlock(), _createElementBlock("li", { key: index }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(getDiceComponent(die))))
      ]))
    }), 128))
  ], 2))
}
}

})